import { createFileRoute } from "@tanstack/react-router";
import { BviFormationDetail } from "@/components/Compliance/Bvi/FormationDetail";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const params = useParams();
  return <BviFormationDetail id={params?.id} />;
}

export const Route = createFileRoute("/_authenticated/compliance/bvi/formations/$id/")({
  component: RouteComponent,
  staticData: { page: "compliance" },
});
